import React from "react";
import ReactDOM from "react-dom";
import * as Sentry from "@sentry/react";
import { Integrations } from "@sentry/tracing";
import "bootstrap/dist/css/bootstrap.css";
import { BrowserRouter, Switch, Route } from "react-router-dom";

import { Router } from "app/routes/Router";
import App from "./app/App";
import NewApp from "./v2/App";
import "./polyfills";
import * as serviceWorker from "./serviceWorker";
import "rc-slider/assets/index.css";

// eslint-disable-next-line @typescript-eslint/no-var-requires
require("dotenv").config();

if (process.env.NODE_ENV === "production") {
  Sentry.init({
    dsn: "https://9ee158c6f446443d9df66c60d56ffb7a@o258703.ingest.sentry.io/1889812",
    environment: process.env.NODE_ENV,
    integrations: [new Integrations.BrowserTracing()],
    tracesSampleRate: 0.2,
  });
}

ReactDOM.render(
  <BrowserRouter>
    <Router>
      <Switch>
        <Route path="/v2" render={() => <NewApp />} />
        <Route path="/" render={() => <App />} />
      </Switch>
    </Router>
  </BrowserRouter>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
